<section class="tw-my-20px tw-mx-12px tw-p-6">
  <div class="tw-flex sm:tw-flex-row tw-flex-col">
    <div
      class="tw-mb-[10px] rtl:tw-ml-2 ltr:tw-mr-2"
      *ngFor="let item of model"
    >
      <div>
        <ul class="list-group">
          <!-- operator -->
          <li
            class="list-group-item list-group-bg dark:tw-text-gray-100 tw-flex tw-justify-between tw-items-center tw-py-3 tw-h-[50px]"
          >
            <span>{{ "common.aggregator" | translate }}</span>
            <div class="tw-flex tw-items-center">
              <span class="value">{{
                item?.operator | enumToText : SmsAggregatorsEnumValues
              }}</span>
              <div
                class="tw-w-[26px]"
                [mobileOperatorImg]="{
                  mobileOperator: item?.operator,
                  mobileOperatorEnumValue:
                    item?.operator | enumToText : SmsAggregatorsEnumValues
                }"
              ></div>
            </div>
          </li>

          <!-- recipientCount -->
          <li
            class="list-group-item list-group-bg dark:tw-text-gray-100 tw-flex tw-justify-between tw-items-center tw-py-3"
          >
            <span>{{ pageVocabs + "recipientCount" | translate }}</span>
            <span class="value">{{ item?.totalCount | numberSeparator }}</span>
          </li>

          <!-- resolutionOfParliamentPrice -->
          <li
            class="list-group-item list-group-bg dark:tw-text-gray-100 tw-flex tw-justify-between tw-items-center tw-py-3"
          >
            <span>{{
              pageVocabs + "resolutionOfParliamentPrice" | translate
            }}</span>
            <div class="tw-font-medium tw-text-lg">
              <span>{{
                item?.resolutionOfParliamentPrice | numberSeparator
              }}</span>
              <span>{{ "common.currency" | translate }}</span>
            </div>
          </li>

          <!-- resolutionPrice -->
          <li
            class="list-group-item list-group-bg dark:tw-text-gray-100 tw-flex tw-justify-between tw-items-center tw-py-3 flex-wrap"
          >
            <span class="tw-pl-3"
              >{{ pageVocabs + "resolutionPrice" | translate }}
            </span>
            <div class="tw-font-medium tw-text-lg">
              <span>{{
                item?.sendPrice - item?.resolutionOfParliamentPrice
                  | numberSeparator
              }}</span>
              <small class="rtl:tw-mr-[2px] ltr:tw-ml-[2px] tw-text-[12px]">{{
                "common.currency" | translate
              }}</small>
            </div>
          </li>

          <!-- sendPrice -->
          <li
            class="list-group-item list-group-bg dark:tw-text-gray-100 tw-flex tw-justify-between tw-items-center tw-py-3"
          >
            <span>{{ pageVocabs + "sendPrice" | translate }}</span>
            <div class="tw-font-medium tw-text-lg tw-text-green-700">
              <span>{{ item?.sendPrice | numberSeparator }}</span>
              <span>{{ "common.currency" | translate }}</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- smsText -->
      <div
        class="list-group-item tw-border dark:tw-bg-dark-100/80 tw-border-gray-100 dark:tw-border-dark-100 tw-rounded-md dark:tw-text-gray-100 tw-h-[424px] tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 tw-whitespace-pre-wrap tw-overflow-y-auto dir-rtl tw-text-right rounded-1"
      >
        <div
          class="tw-flex tw-justify-start tw-items-center tw-border-b dark:tw-border-dark-100 tw-text-gray-700 dark:tw-text-gray-300 tw-pb-2"
        >
          <i class="mdi mdi-message-cog tw-ml-2 tw-mb-1 mdi-20px"></i>
          <span class="tw-font-medium"
            >{{ "common.smsText" | translate }}
          </span>
        </div>
        <div
          class="font-vazir-ui tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200 tw-text-[14px]"
          copyToClipboard
        >
          {{ item?.smsBody }}
        </div>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-justify-center tw-w-full">
    <!-- cancel -->
    <a
      mat-ripple
      class="btn tw-mx-[5px] button-shadow w-75"
      [themeColor]="'cancel-btn'"
      (click)="onClose()"
    >
      {{ "common.cancel" | translate }}
    </a>

    <!-- Confirmation -->
    <button
      mat-ripple
      class="btn button-shadow tw-w-full btn-hover-rise"
      [themeColor]="'btn'"
      (click)="onSubmit()"
    >
      {{ "common.finalConfirmation" | translate }}
      <i class="fas fa-check tw-mt-1 tw-mr-1 tw-text-white"></i>
    </button>
  </div>
</section>
